import { Button, CircularProgress, Divider, FormControlLabel, Radio, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import RadioIconUnchecked from '../Assets/RadioIconUnchecked.svg'
import RadioIconChecked from '../Assets/RadioIconChecked.svg'
import VisaIcon from '../Assets/VisaIcon.svg'
import MastercardIcon from '../Assets/MastercardIcon.svg'
import { ReactComponent as CreditCardIcon } from '../Assets/CreditCardIcon.svg'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import ModalExpSelect from 'Components/Elements/Forms/ModalExpSelect/ModalExpSelect'
import { useEffect, useState } from 'react'
import CreditCardNumber from './CreditCardNumber'
import { storeElement } from 'GlobalStores/StoreElement'
import storeUser from 'GlobalStores/User/StoreUser'
import Errors from 'Components/Elements/Errors/Errors'
import { useCreditcardAliases } from '../Hooks/useCreditcardAliases'

const AddCreditCard = observer(({ afterAction = () => {}, overrideSubmit = false, OverrideButtonComponent = null, OverrideSetCreditCard = null }) => {
    const { setCreditCard, handleSave, loading, error } = useCreditcardAliases()

    const translate = useTranslate()
    const [expiryDate, setExpiryDate] = useState('')
    const [cardNumber, setCardNumber] = useState('')
    const [nameOnCard, setNameOnCard] = useState('')
    const [cvv, setCvv] = useState('')

    const monthOptionsFactory = () => {
        const lm = []
        for (let i = 1; i <= 12; i++) {
            const m = i < 10 ? '0' + i : i
            lm.push(m.toString())
        }
        return lm
    }

    const yearOptionsFactory = () => {
        const min = new Date().getFullYear()
        const max = 10
        const ly = []
        for (let i = 0; i <= max; i++) {
            const year = `${min + i}`
            ly.push(year)
        }
        return ly
    }
    const [month, year] = expiryDate.split('/')

    const isReadyToSave = () => {
        return cardNumber.length === 16 && nameOnCard.length > 0 && cvv.length >= 3 && expiryDate.length === 5
    }

    const handleSaveCreditCard = async () => {
        await handleSave({ cardNumber, expiryDate, nameOnCard, cvv, callback: afterAction, userCountry: storeUser.CustomerData().Country() })
    }

    useEffect(() => {
        setCreditCard({
            card_number: cardNumber,
            exp_date: expiryDate,
            name_on_card: nameOnCard,
            cvv: cvv
        })
        if (OverrideSetCreditCard) {
            OverrideSetCreditCard(cardNumber, expiryDate, nameOnCard, cvv)
        }
    }, [cardNumber, expiryDate, nameOnCard, cvv, setCreditCard, afterAction, OverrideSetCreditCard])

    return (
        <Stack
            sx={{
                border: '2px solid #99BCDF',
                borderRadius: '8px',
                padding: {
                    xs: '24px 16px',
                    md: '24px'
                },
                paddingBottom: '40px',
                flexDirection: 'column',
                backgroundColor: '#F4F8FB',
                marginTop: '16px'
            }}
            id="add-credit-card-form">
            <Stack
                direction={{
                    xs: 'column',
                    md: 'row'
                }}
                justifyContent={'space-between'}
                width={'100%'}>
                <FormControlLabel
                    control={
                        <Radio
                            disableFocusRipple
                            disableRipple
                            checked={true}
                            onChange={() => {}}
                            icon={<img src={RadioIconUnchecked} alt="RadioIconUnchecked" />}
                            checkedIcon={<img src={RadioIconChecked} alt="RadioIconChecked" />}
                            sx={{ paddingY: '0px', paddingRight: '24px', paddingLeft: '12px' }}
                            disabled={loading}
                        />
                    }
                    label={
                        <Stack direction={'row'} gap={'16px'} alignItems={'center'}>
                            <Typography variant="body5" fontSize={'16px'} fontWeight={'700'} fontFamily={'Inter, NotoSansThai'} color="#003B6F">
                                {translate('new_credit_card')}
                            </Typography>
                        </Stack>
                    }
                />
                <Stack
                    direction={'row'}
                    gap={'8px'}
                    alignItems={'center'}
                    sx={{
                        paddingLeft: {
                            xs: '46px',
                            md: '0px'
                        },
                        paddingTop: {
                            xs: '8px',
                            md: '0px'
                        }
                    }}>
                    <img src={VisaIcon} alt="VisaIcon" />
                    <img src={MastercardIcon} alt="MastercardIcon" />
                    {/* <img src={AmericanExpressIcon} alt="AmericanExpressIcon" /> */}
                </Stack>
            </Stack>
            <Stack
                pl={{
                    xs: '0px',
                    md: '46px'
                }}
                pr={{
                    xs: '0px',
                    md: '0px'
                }}>
                <Stack
                    paddingY={{
                        xs: '24px',
                        md: '40px'
                    }}>
                    <Divider sx={{ borderColor: '#CCDEEF' }} />
                </Stack>
                <Stack
                    gridTemplateColumns={'1fr 1fr'}
                    gap={'24px'}
                    display={{
                        xs: 'flex',
                        md: 'grid'
                    }}>
                    <Stack sx={{ height: '80px' }}>
                        <label htmlFor="credit-card-name-on-card" style={{ paddingLeft: '16px', paddingBottom: '8px' }}>
                            <Typography variant="body5" fontSize={'14px'} fontWeight={'400'} fontFamily={'Inter, NotoSansThai'} color="#8A9BB0">
                                {translate('name_on_card')}
                            </Typography>
                        </label>
                        <input
                            id="credit-card-name-on-card"
                            type="text"
                            style={{
                                border: '1px solid #CCDEEF',
                                borderRadius: '8px',
                                padding: '10px 16px',
                                height: '50px',
                                outline: 'none',
                                fontSize: '16px',
                                fontWeight: '400',
                                fontFamily: 'Inter, NotoSansThai',
                                color: '#003B6F',
                                boxSizing: 'border-box'
                            }}
                            value={nameOnCard}
                            onChange={e => setNameOnCard(e.target.value)}
                            disabled={loading}
                        />
                    </Stack>
                    <CreditCardNumber setCardNumber={setCardNumber} loading={loading} />
                    <Stack
                        sx={{
                            height: '80px',
                            label: {
                                span: { fontSize: '14px', fontWeight: '400', fontFamily: 'Inter, NotoSansThai', color: '#8A9BB0!important', lineHeight: 1.5 }
                            },
                            '& .MuiInputBase-input': {
                                border: '1px solid #CCDEEF!important',
                                backgroundColor: 'white!important',
                                borderRadius: '8px',
                                padding: '10px 16px',
                                height: '50px',
                                outline: 'none',
                                fontSize: '16px',
                                fontWeight: '400',
                                fontFamily: 'Inter, NotoSansThai'
                            }
                        }}>
                        <ModalExpSelect
                            label={translate('exp_date')}
                            onSet={(month, year) => {
                                setExpiryDate(`${month}/${year.slice(-2)}`)
                            }}
                            options={{ month: monthOptionsFactory(), year: yearOptionsFactory() }}
                            value={{ month: month || '', year: year ? '20' + year : '' }}
                            disabled={loading}
                        />
                    </Stack>
                    <Stack sx={{ height: '80px' }}>
                        <label htmlFor="credit-card-cvv" style={{ paddingLeft: '16px', paddingBottom: '8px' }}>
                            <Typography
                                variant="body5"
                                fontSize={'14px'}
                                fontWeight={'400'}
                                fontFamily={'Inter, NotoSansThai'}
                                color="#8A9BB0"
                                component={'span'}>
                                {translate('cvv')}
                            </Typography>
                        </label>
                        <input
                            id="credit-card-cvv"
                            type="password"
                            style={{
                                border: '1px solid #CCDEEF',
                                borderRadius: '8px',
                                padding: '10px 16px',
                                height: '50px',
                                outline: 'none',
                                fontSize: '16px',
                                fontWeight: '400',
                                fontFamily: 'Poppins,Inter, NotoSansThai',
                                color: '#003B6F',
                                boxSizing: 'border-box'
                            }}
                            maxLength={4}
                            value={cvv}
                            onChange={e => setCvv(e.target.value)}
                            disabled={loading}
                        />
                    </Stack>
                </Stack>
                {!overrideSubmit && (
                    <Stack justifyContent={'center'} alignItems={'center'} mt="24px" direction={'column'} gap={'16px'}>
                        {error && (
                            <Stack width={'100%'}>
                                <Errors list={typeof error === 'string' ? [error] : error} />
                            </Stack>
                        )}
                        <Button
                            variant="contained"
                            disableRipple
                            disableFocusRipple
                            disableTouchRipple
                            disableElevation
                            disabled={!isReadyToSave() || loading}
                            fullWidth={storeElement.dynamicWidth <= 834 ? true : false}
                            sx={{
                                backgroundColor: '#5A8FC3',
                                color: 'white',
                                padding: '10px 16px',
                                borderRadius: '32px',
                                '&:disabled': {
                                    backgroundColor: '#99BCDF',
                                    color: 'white'
                                },
                                fontFamily: 'Inter, NotoSansThai'
                            }}
                            onClick={handleSaveCreditCard}>
                            {loading ? (
                                <Stack>
                                    <CircularProgress size={20} color="inherit" />
                                </Stack>
                            ) : (
                                translate('save')
                            )}
                        </Button>
                    </Stack>
                )}
                {OverrideButtonComponent && OverrideButtonComponent}
            </Stack>
        </Stack>
    )
})

export default AddCreditCard
